import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MdHome, MdChevronRight } from 'react-icons/md';
import { useAuth } from 'context/AuthContext';

const Breadcrumbs = () => {
  const location = useLocation();
  const { currentLang } = useAuth();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Функция для получения названия страницы по пути
  const getPageName = (path, index) => {
    const pathMap = {
      'admin': currentLang === 'ru' ? 'Админ панель' : 'Admin Panel',
      'seo': 'SEO',
      'auth': currentLang === 'ru' ? 'Авторизация' : 'Authentication',
      'dashboard': currentLang === 'ru' ? 'Дашборд' : 'Dashboard',
      'sites': currentLang === 'ru' ? 'Сайты' : 'Sites',
      'links': currentLang === 'ru' ? 'Ссылки' : 'Links',
      'donors': currentLang === 'ru' ? 'Доноры' : 'Donors',
      'tasks': currentLang === 'ru' ? 'Задачи' : 'Tasks',
      'sign-in': currentLang === 'ru' ? 'Вход' : 'Sign In',
      'user': currentLang === 'ru' ? 'Пользователь' : 'User',
      'default': currentLang === 'ru' ? 'Главная' : 'Main',
      'marketplace': currentLang === 'ru' ? 'Маркетплейс' : 'Marketplace',
      'profile': currentLang === 'ru' ? 'Профиль' : 'Profile',
      'tables': currentLang === 'ru' ? 'Таблицы' : 'Tables',
    };

    // Для динамических роутов (например, sites/:id)
    if (path === 'sites' && pathnames[index + 1] && !isNaN(pathnames[index + 1])) {
      return currentLang === 'ru' ? 'Детали сайта' : 'Site Details';
    }

    return pathMap[path] || path;
  };

  // Функция для получения пути до определенного уровня
  const getPathTo = (index) => {
    return '/' + pathnames.slice(0, index + 1).join('/');
  };

  // Если мы на главной странице, не показываем крошки
  if (pathnames.length === 0) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400 mb-1">
      {/* Домашняя иконка */}
      <Link
        to="/"
        className="flex items-center hover:text-brand-500 transition-colors"
      >
        <MdHome className="h-4 w-4" />
      </Link>

      {/* Разделитель */}
      <MdChevronRight className="h-4 w-4" />

      {/* Крошки */}
      {pathnames.map((path, index) => {
        const isLast = index === pathnames.length - 1;
        const pageName = getPageName(path, index);
        const pathTo = getPathTo(index);

        return (
          <React.Fragment key={index}>
            {isLast ? (
              // Последний элемент - не кликабельный
              <span className="text-gray-900 dark:text-white font-medium">
                {pageName}
              </span>
            ) : (
              // Кликабельные элементы
              <>
                <Link
                  to={pathTo}
                  className="hover:text-brand-500 transition-colors"
                >
                  {pageName}
                </Link>
                <MdChevronRight className="h-4 w-4" />
              </>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs; 